import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { StackScreen } from '@life-line-lab/components-react'
import { Helmet } from 'react-helmet';

import { isUndefined, isNil } from 'lodash';
import DriverCreateForm from 'Components/new-driver-management/driver-create-form';

import { toaster, encode } from 'Helpers/index';
import { createExternalDriver } from 'Services/new-driver-management.services';
import { useAccessControlList, useSession } from 'Hooks/index';

const DriverCreate = () => {

  const history = useHistory();
  const { t }= useTranslation();

  const { roleTypes } = useSession();

  const permission = useAccessControlList({
    roleTypes: roleTypes,
    resource: 'Rider_Management'
  });

  // permissions
  const canCreate = permission.rights.includes("CREATE");

  useEffect(() => {
    document.body.classList.add('stack-screen--open');
    return () => document.body.classList.remove('stack-screen--open');
  }, []);

  const handleCloseStackScreen = () => {
    history.push('/driver-management/driver');
  }

  const handleCreateDriver = async (data) => {
    if (isUndefined(data)) return;
    const responseData = await createExternalDriver(data)
    if (responseData && isNil(responseData.error)) {
      const id = encode(responseData.profile._id);
      history.push(`/driver-management/driver/create/success/${id}`);
    } else {
      console.log(responseData.error)
      if (typeof responseData.error.message === "string") {
        toaster("error", responseData.error.message);
      } else {
        toaster("error", responseData.error.message.message.replace("\"", ""));
      }
    }
  }

  return (canCreate ?
    <StackScreen
      title={
        <div>
          <img
            alt={t('alt.logo')}
            src="/assets/images/banner_logo.png"
            height={30}
          />
        </div>
      }
      isOpen={true}
      renderHeader={<div></div>}
      onClose={handleCloseStackScreen}
    >
      <Helmet>
        <title>{t('pageTitle.createDriver')}</title>
      </Helmet>

      <DriverCreateForm
        onSubmitExternal={handleCreateDriver}
        driverDetails={{}}
      />
    </StackScreen> :
    <></>
  )
}

export default DriverCreate